module.exports = __webpack_public_path__ + "img/bijela.e8068a55.svg";